export var BucketTypeEnum;
(function (BucketTypeEnum) {
    BucketTypeEnum["INTERVENTIONS"] = "interventions";
    BucketTypeEnum["ENTITIES"] = "entities";
})(BucketTypeEnum || (BucketTypeEnum = {}));
